import React from "react";
import startBtnArrowImg from "../../../../../assets/images/startBtnArrowImg.png";
import startBtnMobile from "../../../../../assets/images/startBtnMbl.png";
import './TutorialStart.css';

const TutorialStart = ({title, description}) => {
  return (
    <div className="tutorialContentBox tutorialStartContentBox">
      <div className="imgBtnBox">
        {/* Use Bootstrap utility display classes for responsiveness */}
        <img
          alt="startBtnArrowImg"
          className="tutorialStartImg desktop"
          src={startBtnArrowImg}
        />
        <img
          alt="startBtnArrowImg"
          className="tutorialStartImg mobile"
          src={startBtnMobile}
        />
      </div>
      <p className="title">{title}</p>
      <p className="desc">
        {description}
      </p>
    </div>
  );
};

export default TutorialStart;
